import React from 'react';
import { Layout } from 'antd';
import { Box, Grid2 } from '@mui/material';
import { Icons } from './SocialMedia';
import UsersSection from './UsersSection';
import AboutSection from './AboutSection';

import logo from 'assets/images/utriper-black-logo.png';

const { Footer } = Layout;

const FooterComponent = () => {
    return (
        <Footer
            style={{
                backgroundColor: '#f5f5f5',
                padding: '2rem 1rem',
                borderTop: '1px solid #e8e8e8',
            }}>
            <Grid2 container spacing={2} justifyContent="center" alignItems="flex-start">
                {/* Logo */}
                <Grid2 xs={12} sm={6} md={3} lg={3} xl={3}>
                    <Box
                        sx={{
                            width: '11rem',
                            height: '4rem',
                            mx: 'auto',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <img src={logo} alt="utriper logo" style={{ maxWidth: '100%', maxHeight: '100%' }} />
                    </Box>
                </Grid2>

                {/* Social Icons */}
                <Grid2 xs={12} sm={6} md={2} lg={3} xl={3}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: { xs: 'center', sm: 'flex-start' },
                            gap: 1,
                            flexWrap: 'wrap',
                        }}>
                        <Icons />
                    </Box>
                </Grid2>

                {/* Users Section */}
                <Grid2 xs={6} sm={6} md={3} lg={2} xl={3}>
                    <UsersSection />
                </Grid2>

                {/* About Section */}
                <Grid2 xs={6} sm={6} md={4} lg={4} xl={3}>
                    <AboutSection />
                </Grid2>
            </Grid2>
        </Footer>
    );
};

export default FooterComponent;
